import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"close\"><path fill=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M19.071 3.515a1 1 0 0 1 1.492 1.327l-.078.087L4.93 20.486a1 1 0 0 1-1.492-1.327l.078-.088L19.07 3.515Z\" /><path d=\"M20.485 19.071a1 1 0 0 1-1.326 1.492l-.088-.078L3.515 4.93A1 1 0 0 1 4.84 3.437l.088.078L20.485 19.07Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol